// extracted by mini-css-extract-plugin
module.exports = {"title":"recommendations_title__LhCgM"};